import { memo, useCallback, useMemo } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { BzButton } from "../../../components";
import { handleModal, handleModalData } from "../../../redux/actions/modals";
import { getOrderInfo, getScripOrderInfo } from "../../../redux/actions/orders";
import { ORDER_ENTRY_GRID_REF, convertScripResponseWatchlistGrid, getArrSipScripOrderInfo } from "../../../utils/global_functions";
import { ALL_ORDERS_STATUS, ORDER_TYPES, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import CancelOrderModal from "../../PlaceOrderTypes/CancelOrderModal";
import ZeroStates from "../../ZeroStates";
import { getScripbyTokenAndMktSegId } from "../../../apis";
import { toastConfig } from "../../../redux/actions/toast";
import _ from "lodash";


const SipDetails = ({ ...props }) => {

    const data = useMemo(() => props?.data, [props?.data]);
    const dispatch = useDispatch();

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const handleModifyOrder = async () => {
        const arrScrips = [{ mkt: data?.exchangeSegment, token: data?.scrip_token }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        const isBuySell = data?.transaction_type === "BUY" ? 0 : 1;
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, capPrice: data?.cap_price, quantity: data?.invested_qty_or_val, numberOfInstallment: data?.no_of_installments, scripLot: data?.totalQuantity / data?.market_lot }));
        ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, frequency: data?.frequency_type, day_date: data?.frequency_monthly_option }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
        dispatch(getScripOrderInfo({
            isBuySell, activeExchangeId: gridFormatData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: gridFormatData[0],
            isModifyOrder: true
        }));
        // Vinit Raut : 29-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- Start  
        dispatch(handleModalData({ orderData: data, data: { orderEntryTab: ORDER_TYPES.EQUITY_SIP } }));
        // Vinit Raut : 29-01-2024 : BT-107418 - Breeze – SIP Order book bug fixing -- End
    };
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End


    const handleCancelOrder = useCallback(() => {
        const scripData = getArrSipScripOrderInfo(data);
        const isBuySell = data?.transaction_type === "BUY" ? 0 : 1;
        dispatch(getOrderInfo(data));
        dispatch(getScripOrderInfo({ isBuySell, activeExchangeId: scripData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData }));
        dispatch(handleModal([{ 'CANCEL_ORDER_MODAL': true }], true));

    }, [data, dispatch]);

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const handleReOrder = async () => {
        const arrScrips = [{ mkt: data?.exchangeSegment, token: data?.scrip_token }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        const isBuySell = data?.transaction_type === "BUY" ? 0 : 1;
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, capPrice: data?.cap_price, quantity: data?.invested_qty_or_val, numberOfInstallment: data?.no_of_installments, scripLot: data?.totalQuantity / data?.market_lot }));
        ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(curr => ({ ...curr, frequency: data?.frequency_type, day_date: data?.frequency_monthly_option }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
        dispatch(getScripOrderInfo({
            isBuySell, activeExchangeId: gridFormatData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: gridFormatData[0],
            isReOrder: true
        }));

    };
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

    // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start
    const handleSipOrderStatus = (status) => {
        if (status === ALL_ORDERS_STATUS.ORDER_STATUS_DEACTIVATED) {
            return dispatch(toastConfig({ show: true, message: 'Stop functionality is work in progress from backend', button: [{ btnName: "ok", type: "CLOSE", className: "btn btn-outline-active ms-3" }] }));
        }
        dispatch(handleModal([{ 'SIP_ORDER_STATUS_MODAL': true }], true));
        dispatch(handleModalData({ orderData: data, sipOrderStatus: status }));
    };
    // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End
    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col md={5} className='mrgauto p-3'>
                        <Row className='g-0 my-3'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>Order History</div>
                            </Col>
                            {data && data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_PENDING &&
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-sm btn-outline text-capitalize ms-3' onClick={handleCancelOrder}>CANCEL ORDER</BzButton>
                                    <BzButton className='btn btn-sm btn-primary text-capitalize ms-3' onClick={handleModifyOrder}>MODIFY</BzButton>

                                </Col>
                            }

                            {/* Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start */}
                            <Col className='d-flex justify-content-end align-items-center'>
                                {data && data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_RUNNING &&
                                    <BzButton className='btn btn-sm btn-outline text-capitalize ms-3' onClick={() => handleSipOrderStatus(ALL_ORDERS_STATUS.ORDER_STATUS_RUNNING)}>PAUSE</BzButton>
                                }

                                {data && data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_STOPPED &&
                                    <BzButton className='btn btn-sm btn-primary text-capitalize ms-3' onClick={() => handleSipOrderStatus(ALL_ORDERS_STATUS.ORDER_STATUS_STOPPED)}>RESUME</BzButton>
                                }

                                {data && (data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_RUNNING || data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_STOPPED) &&
                                    <BzButton className='btn btn-sm btn-primary text-capitalize ms-3' onClick={() => handleSipOrderStatus(ALL_ORDERS_STATUS.ORDER_STATUS_DEACTIVATED)}>STOP</BzButton>
                                }
                            </Col>

                            {data && (data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_COMPLETED || data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_DEACTIVATED || data?.updated_status === ALL_ORDERS_STATUS?.ORDER_STATUS_CANCELLED) &&
                                <Col className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-sm btn-primary text-capitalize ms-3' onClick={handleReOrder}>RE-ORDER</BzButton>
                                </Col>
                            }
                            {/* Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End */}
                        </Row>
                        <Row className='g-0'>
                            {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                            {data?.orderHistory?.length > 0 ?
                                // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
                                <Col>
                                    <table className='table table-hover table-bordered table-striped'>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>
                                                    <div className='font-size2 color-text text-capitalize py-2'>Date</div>
                                                </th>
                                                <th className='text-center'>
                                                    <div className='font-size2 color-text text-capitalize py-2'>Order Status</div>
                                                </th>
                                                <th className='text-center'>
                                                    <div className='font-size2 color-text text-capitalize py-2'>Qty</div>
                                                </th>
                                                <th className='text-center'>
                                                    <div className='font-size2 color-text text-capitalize py-2'>Amount</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.orderHistory?.map(element =>
                                                <tr>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{new Date(element?.transaction_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' })?.replace(/(\d{2}) (\w+) (\d{2})/, "$1 $2'$3")}</div>
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>
                                                            {element?.remarks}
                                                        </div>
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{element?.traded_quantity}</div>
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className='font-regular font-size2 color-text text-capitalize py-1'>{element?.amount}</div>
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td className='text-center' colSpan="2">
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'></div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'>{_.sumBy(data?.orderHistory, (obj) => obj?.traded_quantity)}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'>Total Transaction {` ${_.sumBy(data?.orderHistory, (obj) => Number(obj.amount))}`}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Col>
                                // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
                                : <div className='zero-state-alerts zero-state-alerts-lg'>
                                    <ZeroStates subText={`No orders so far.${data?.installment_date?.toUpperCase() !== 'NA' ? `Next order due date ${data?.installment_date}` : ''}`} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                </div>}
                            {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}

                        </Row>
                    </Col>
                </Row>
            </Container>
            <CancelOrderModal />
            {/* <OrderEntry orderEntryTab={ORDER_TYPES.EQUITY_SIP} activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={setActiveButtonToggleIndex} /> */}


        </>
    );
};

export default memo(SipDetails);